import { h } from "preact";

import { imageUrl } from "../../../foundation/utils/image";
import BouncingShapes, { BouncingShapeType } from "../BouncingShapes";

import styles from "./ImageFigmaToZeplin.module.css";

function ImageFigmaToZeplin() {
    return (
        <div class={styles.figmaToZeplin}>
            <img src={imageUrl("img/icFigmaLogo.svg")}/>
            <BouncingShapes
                class={styles.bouncingShapes}
                shapeCount={4}
                animationDuration={500}
                colors={["#1abcfd", "#a259ff", "#ff7261", "#febd37"]}
                shapes={BouncingShapeType.Circle}/>
            <img src={imageUrl("img/icZeplin.svg")}/>
        </div>
    );
}

export default ImageFigmaToZeplin;
